import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { BoxProps, box } from './Box'
import { Color } from '../constants/color'
import { theme } from '../constants/theme'
import { StyleProps, createStyles } from '../utils'

type CounterFontStyle = {
  fontSize: number
  size: number
}

type CounterStyle = {
  backgroundColor: Color
  color: Color
}

const COUNTER_STYLES: Record<CounterColor, CounterStyle> = {
  'light-blue': { backgroundColor: Color.LIGHT_BLUE, color: Color.WHITE },
  'light-green': {
    backgroundColor: Color.LIGHT_GREEN,
    color: Color.DARK_GREEN,
  },
  'lighter-blue': { backgroundColor: Color.LIGHTER_BLUE, color: Color.BLUE },
  blue: { backgroundColor: Color.BLUE, color: Color.WHITE },
  green: { backgroundColor: Color.GREEN, color: Color.WHITE },
  purple: { backgroundColor: Color.PURPLE, color: Color.WHITE },
  red: { backgroundColor: Color.RED, color: Color.WHITE },
}

const FONT_STYLES: Record<CounterSize, CounterFontStyle> = {
  large: { fontSize: theme.font.size[4], size: 28 },
  medium: { fontSize: theme.font.size[6], size: 20 },
  small: { fontSize: theme.font.size[6.5], size: 16 },
}

export type CounterColor =
  | 'blue'
  | 'green'
  | 'light-blue'
  | 'light-green'
  | 'lighter-blue'
  | 'purple'
  | 'red'

export type CounterProps = Omit<BoxProps, 'size'> & {
  children?: ReactNode
  color?: CounterColor
  size?: CounterSize
  styles?: StyleProps
  title?: string
}

export type CounterSize = 'small' | 'medium' | 'large'

export const Counter = styled.div<CounterProps>((props) => {
  const { backgroundColor, color } = COUNTER_STYLES[props.color ?? 'green']
  const { fontSize, size } = FONT_STYLES[props.size ?? 'medium']

  return {
    ...box(props),
    alignItems: 'center',
    backgroundColor,
    borderRadius: 999,
    color,
    display: 'flex',
    flexShrink: 0,
    fontSize,
    fontWeight: theme.font.weight.bold,
    height: size,
    justifyContent: 'center',
    lineHeight: `${size}px`,
    textAlign: 'center',
    userSelect: 'none',
    width: size,
    ...createStyles(props.styles),
  }
})
